import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
export default store => {
  return {
    path: "collection/:collectionId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [AssessmentDetails(store)],
  };
};
